<template>
  <div class="quote-pax">
    <elwrapper v-if="label" :label="label" :largelabel="largelabel">
      <div class="quote-pax__row">
        <f-number
          v-model="paxValue"
          :disabled="disabled"
          smlabel
          @focus="(e) => $emit('focus', e)"
          @blur="(e) => $emit('blur', e)"
        />
        <div v-if="unit" class="quote-pax__unit">{{ unit }}</div>
      </div>
    </elwrapper>
    <div v-else class="quote-pax__row a-field">
      <f-number
        v-model="paxValue"
        :disabled="disabled"
        smlabel
        @focus="(e) => $emit('focus', e)"
        @blur="(e) => $emit('blur', e)"
      />
      <div v-if="unit" class="quote-pax__unit">{{ unit }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: null,
    unit: String,
    disabled: Boolean,
    largelabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    paxValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>

<style scoped>
.quote-pax__row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.quote-pax__unit {
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  flex: 0 0 auto;
}
</style>
